jQuery(function ($) {
  const numberOfElementsInPage = 10;
  const numberTotalOfElements = $(".portlet-blogs").length;

  lactalis_loadmore_params.max_page = Math.ceil(
    numberTotalOfElements / numberOfElementsInPage
  );

  $(".portlet-blogs")
    .slice(numberOfElementsInPage, numberTotalOfElements)
    .hide();

  if (numberTotalOfElements === 0) {
    $(".btn_blue_to_white").hide(); // Si es la última página, ocultamos el botón
  }

  $(".btn_blue_to_white").on("click", function () {
    lactalis_loadmore_params.current_page++;
    $(".portlet-blogs:hidden").slice(0, numberOfElementsInPage).slideDown(300);
    if (
      lactalis_loadmore_params.current_page > lactalis_loadmore_params.max_page
    ) {
      $(".btn_blue_to_white").hide(); // Si es la última página, ocultamos el botón
    }
  });
});
